import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import '../App.css';

import projectad from '../Images/project-ad.jpg';
import projectbl from '../Images/project-bl.jpg';
import projecticw from '../Images/icw-project.jpg';
import laptop from '../Images/laptop-myresource.jpg'
import projectcomm from '../Images/communitee-project.jpg';
import projectbizgainz from '../Images/bizgainz-project.jpg';

class HomeNew extends Component {
  
    constructor(props) {
        super();
        this.props = props;
        this.state = {
          Tab1ClassName: "tab-container-selected",
          Tab2ClassName: "tab-container",
          Tab3ClassName: "tab-container",
          Tab4ClassName: "tab-container",

          Tab1Icon1ClassName: "tab-icon-hidden",
          Tab1Icon2ClassName: "tab-icon-visible",
          Tab2Icon1ClassName: "tab-icon-visible",
          Tab2Icon2ClassName: "tab-icon-hidden",
          Tab3Icon1ClassName: "tab-icon-visible",
          Tab3Icon2ClassName: "tab-icon-hidden",
          Tab4Icon1ClassName: "tab-icon-visible",
          Tab4Icon2ClassName: "tab-icon-hidden",

          AllWorkProjectsStyle: "block",
          GamDevProjectsStyle: "none",
          UXDesignProjectsStyle: "none",
          WebDevProjectsStyle: "none",

          tab1ContainerStyle: {},
          tab2ContainerStyle: {},
          tab3ContainerStyle: {},
          tab4ContainerStyle: {}


        }
    }
  
  componentDidMount() {
    window.scrollTo(0, 0);

    // while (true) {
    //   this.setState({Tab1ClassName: "tab-container-selected"});

    // }
  }

  

  componentWillUnmount(){

  }

  rerouteTo(URL) {
    // const navigate = useNavigate();
    // navigate('/home')
  }  

  render () {

    return (
        
      <div id="home">

          <div className="home-me-container">
            <p className="home-title-label"><span>UX Design</span>•<span>Software Development</span></p>
            <p className="project-text-medium">Hey, I’m Brandon! I blend UX design and software development to build seamless, human-centered digital experiences.</p>
          </div>

          <div class="projects-container">
            <p className="project-text-small">Projects</p>
            <div className="projects-container-column">
              <div className="projects-container-row">
                

                <Link to="/portals" class="link"><div className="project">
                  <img className="project-image-rounded" src={laptop} alt=""></img>
                  <p className="project-title">Insurance Company Portals</p>
                  <p className="project-subtext">UI design and dev of 2 customer portals</p>
                </div></Link>

                <Link to="/bajookieland" class="link"><div className="project">
                  <img className="project-image-rounded" src={projectbl} alt=""></img>
                  <p className="project-title">Bajookieland Game</p>
                  <p className="project-subtext">iOS app developed in Unity</p>
                </div></Link>

                <Link to="/bizgainz" class="link"><div className="project">
                  <img className="project-image-rounded" src={projectbizgainz} alt=""></img>
                  <p className="project-title">BizGainz E-Commerce Platform</p>
                  <p className="project-subtext">E-Commerce Web Services</p>
                </div></Link>
              </div>
              <div className="projects-container-row">
                
                <Link to="/communitee" class="link"><div className="project">
                  <img className="project-image-rounded" src={projectcomm} alt=""></img>
                  <p className="project-title">Communitee.io</p>
                  <p className="project-subtext">Messaging platform & e-commerce shop</p>
                </div></Link>

                <Link to="/redesign" class="link"><div className="project">
                  <img className="project-image-rounded" src={projecticw} alt=""></img>
                  <p className="project-title">Website Redesign</p>
                  <p className="project-subtext">Full UX lifecycle for corporate website</p>
                  </div></Link>
                  
                <Link to="/additive-drinking" class="link"><div className="project">
                  <img className="project-image-rounded" src={projectad} alt=""></img>
                  <p className="project-title">Additive Drinking</p>
                  <p className="project-subtext">Card game, e-commerce site, and Kickstarter</p>
                </div></Link>

              </div>
            </div>
          </div>

          <div className="endOfHome">
                        
            <p className="project-text-medium">Looking for more?</p>
    
              <Link to="/portfolio"><div className="button-2">
                View All Projects
              </div></Link>
          
          </div>

      </div>
    );
  }
}

export default HomeNew;
